///messagingconversation/list
export const GET_MESSAGING_CONVERSATION_LIST =
  "GET_MESSAGING_CONVERSATION_LIST";
export const GET_MESSAGING_CONVERSATION_LIST_SUCCESS =
  "GET_MESSAGING_CONVERSATION_LIST_SUCCESS";
export const GET_MESSAGING_CONVERSATION_LIST_FAILURE =
  "GET_MESSAGING_CONVERSATION_LIST_FAILURE";

///messagingconversationmessage/search
export const SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST =
  "SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST";
export const SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST_SUCCESS =
  "SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST_SUCCESS";
export const SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST_FAILURE =
  "SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST_FAILURE";

///messagingconversationmessage/send
export const SEND_MESSAGING_CONVERSATION_MESSAGE =
  "SEND_MESSAGING_CONVERSATION_MESSAGE";
export const SEND_MESSAGING_CONVERSATION_MESSAGE_SUCCESS =
  "SEND_MESSAGING_CONVERSATION_MESSAGE_SUCCESS";
export const SEND_MESSAGING_CONVERSATION_MESSAGE_FAILURE =
  "SEND_MESSAGING_CONVERSATION_MESSAGE_FAILURE";

///messagingconversation/update
export const UPDATE_MESSAGING_CONVERSATION = "UPDATE_MESSAGING_CONVERSATION";
export const UPDATE_MESSAGING_CONVERSATION_SUCCESS =
  "UPDATE_MESSAGING_CONVERSATION_SUCCESS";
export const UPDATE_MESSAGING_CONVERSATION_FAILURE =
  "UPDATE_MESSAGING_CONVERSATION_FAILURE";

///messagingconversation/create
export const CREATE_MESSAGING_CONVERSATION = "CREATE_MESSAGING_CONVERSATION";
export const CREATE_MESSAGING_CONVERSATION_SUCCESS =
  "CREATE_MESSAGING_CONVERSATION_SUCCESS";
export const CREATE_MESSAGING_CONVERSATION_FAILURE =
  "CREATE_MESSAGING_CONVERSATION_FAILURE";

///messagingchannel/list
export const GET_MESSAGING_CHANNEL_LIST = "GET_MESSAGING_CHANNEL_LIST";
export const GET_MESSAGING_CHANNEL_LIST_SUCCESS =
  "GET_MESSAGING_CHANNEL_LIST_SUCCESS";
export const GET_MESSAGING_CHANNEL_LIST_FAILURE =
  "GET_MESSAGING_CHANNEL_LIST_FAILURE";

///messagingconversationmessage/start
export const START_MESSAGING_CONVERSATION_MESSAGE =
  "START_MESSAGING_CONVERSATION_MESSAGE";
export const START_MESSAGING_CONVERSATION_MESSAGE_SUCCESS =
  "START_MESSAGING_CONVERSATION_MESSAGE_SUCCESS";
export const START_MESSAGING_CONVERSATION_MESSAGE_FAILURE =
  "START_MESSAGING_CONVERSATION_MESSAGE_FAILURE";

///messagingconversationtemplate/search
export const SEARCH_MESSAGING_CONVERSATION_TEMPLATE =
  "SEARCH_MESSAGING_CONVERSATION_TEMPLATE";
export const SEARCH_MESSAGING_CONVERSATION_TEMPLATE_SUCCESS =
  "SEARCH_MESSAGING_CONVERSATION_TEMPLATE_SUCCESS";
export const SEARCH_MESSAGING_CONVERSATION_TEMPLATE_FAILURE =
  "SEARCH_MESSAGING_CONVERSATION_TEMPLATE_FAILURE";

///messagingconversationparticipant/remove
export const REMOVE_MESSAGING_CONVERSATION_PARTICIPANT =
  "REMOVE_MESSAGING_CONVERSATION_PARTICIPANT";
export const REMOVE_MESSAGING_CONVERSATION_PARTICIPANT_SUCCESS =
  "REMOVE_MESSAGING_CONVERSATION_PARTICIPANT_SUCCESS";
export const REMOVE_MESSAGING_CONVERSATION_PARTICIPANT_FAILURE =
  "REMOVE_MESSAGING_CONVERSATION_PARTICIPANT_FAILURE";

///messagingconversation/markread
export const MARK_MESSAGING_CONVERSATION_READ =
  "MARK_MESSAGING_CONVERSATION_READ";
export const MARK_MESSAGING_CONVERSATION_READ_SUCCESS =
  "MARK_MESSAGING_CONVERSATION_READ_SUCCESS";
export const MARK_MESSAGING_CONVERSATION_READ_FAILURE =
  "MARK_MESSAGING_CONVERSATION_READ_FAILURE";

///messagingconversation/markunread
export const MARK_MESSAGING_CONVERSATION_UNREAD =
  "MARK_MESSAGING_CONVERSATION_UNREAD";
export const MARK_MESSAGING_CONVERSATION_UNREAD_SUCCESS =
  "MARK_MESSAGING_CONVERSATION_UNREAD_SUCCESS";
export const MARK_MESSAGING_CONVERSATION_UNREAD_FAILURE =
  "MARK_MESSAGING_CONVERSATION_UNREAD_FAILURE";

///messagingconversationmessage/markread
export const MARK_MESSAGING_CONVERSATION_MESSAGE_READ =
  "MARK_MESSAGING_CONVERSATION_MESSAGE_READ";
export const MARK_MESSAGING_CONVERSATION_MESSAGE_READ_SUCCESS =
  "MARK_MESSAGING_CONVERSATION_MESSAGE_READ_SUCCESS";
export const MARK_MESSAGING_CONVERSATION_MESSAGE_READ_FAILURE =
  "MARK_MESSAGING_CONVERSATION_MESSAGE_READ_FAILURE";

///messagingconversationmessage/markunread
export const MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD =
  "MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD";
export const MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD_SUCCESS =
  "MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD_SUCCESS";
export const MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD_FAILURE =
  "MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD_FAILURE";

///messagingconversation/data
export const GET_MESSAGING_CONVERSATION_DATA =
  "GET_MESSAGING_CONVERSATION_DATA";
export const GET_MESSAGING_CONVERSATION_DATA_SUCCESS =
  "GET_MESSAGING_CONVERSATION_DATA_SUCCESS";
export const GET_MESSAGING_CONVERSATION_DATA_FAILURE =
  "GET_MESSAGING_CONVERSATION_DATA_FAILURE";

//Messaging Service  Selected Conversation
export const SET_SELECTED_MESSAGING_CONVERSATION =
  "SET_SELECTED_MESSAGING_CONVERSATION";
export const SET_SELECTED_MESSAGING_CONVERSATION_SUCCESS =
  "SET_SELECTED_MESSAGING_CONVERSATION_SUCCESS";
export const SET_SELECTED_MESSAGING_CONVERSATION_FAILURE =
  "SET_SELECTED_MESSAGING_CONVERSATION_FAILURE";

///messagingconversation/close
export const CLOSE_MESSAGING_CONVERSATION = "CLOSE_MESSAGING_CONVERSATION";
export const CLOSE_MESSAGING_CONVERSATION_SUCCESS =
  "CLOSE_MESSAGING_CONVERSATION_SUCCESS";
export const CLOSE_MESSAGING_CONVERSATION_FAILURE =
  "CLOSE_MESSAGING_CONVERSATION_FAILURE";
